var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[_c('navbar'),_c('daily-index'),_c('sector-tables'),_c('third-section'),_c('fourth-table'),_c('fifth-graph'),_c('Footer')],1)}
var staticRenderFns = []

export { render, staticRenderFns }